import PageIndexComponent from '@components/page-index/page-index.view';

export default PageIndexComponent;
